import {fadeOutEffect, fadeInEffect, slideUp, slideDown, simulateClick} from './serie-effects.js';
import Swiper, { Navigation, Pagination, Lazy, Autoplay, startAutoplay, Grid } from 'swiper';

Swiper.use([Navigation, Pagination, Lazy, Autoplay, startAutoplay, Grid]);

let isMobile = false;
let category = document.querySelector('.page__category');

if(window.screen.width >= 1023){
    isMobile = false;
} else {
    isMobile = true;
}

const categoryFunctions = {
    /**
     * Faz a montagem do carousel dos banners de categorias
    */
    setBannersCategories: () => {
        const bannersCategories = document.querySelectorAll('[data-categories-swiper]');

        bannersCategories.forEach((section) => {
            const carousel = section.querySelector('.swiper');
            const next = section.querySelector('.swiper-button-categories-next');
            const prev = section.querySelector('.swiper-button-categories-prev');
            
            const swiper = new Swiper(carousel, {
                slidesPerView: 3,
                navigation: {
                    nextEl: next,
                    prevEl: prev,
                },
                watchOverflow: true,
                preloadImages: false,
                lazy: {
                checkInView: true,
                loadPrevNext: false,
                loadOnTransitionStart: true,
                },
                breakpoints: {
                    1200: {
                        slidesPerView: 7,
                    },
                    1024: {
                        slidesPerView: 5,
                    },
                    768: {
                        slidesPerView: 4
                    },
                },
            });
        });
    },

    /**
     * Ativa o botão de ativar os filtros quando clicar em algum dos itens
    */
    detectClickOnFilterItemAndActiveButton: function(){
        window.addEventListener('load', () => {
            setTimeout(() => {
                let items = Array.from( category.querySelectorAll('#component-products-filter-root .vnda-products-filter-vertical .list-value-image') );
                let button = category.querySelector('#component-products-filter-root .vnda-products-filter-vertical-button-apply');

                if( items.length > 0 ){
                    // Para cada item da ordenação, será criado uma DIV customizada para adicionar no bloco customizado
                    items.forEach(item => {
                        item.addEventListener('click', () => {
                            setTimeout(() => {
                                simulateClick( button );
                            }, 1000);
                        });
                    });
                }
            }, 1000);
        });
    },

    /**
     * Recupera os valores nativos da ordenação padrão da plataforma e monta uma div customizada
    */
    getOrdersSelectionAndBuild: function(){
        window.addEventListener('load', () => {
            setTimeout(() => {
                let orderItems = Array.from( category.querySelectorAll('#component-products-filter-root .vnda-products-filter-vertical-sort-container .component-products-filter-block .list-value-container') );

                if( orderItems.length > 0 ){
                    // Para cada item da ordenação, será criado uma DIV customizada para adicionar no bloco customizado
                    orderItems.forEach(item => {
                        let text = item.querySelector('.list-value-text').textContent;
                        let optionItem = `<div data-value="${text}">${text}</div>`;
                        let orderList = category.querySelector('.filters__order .order__wrapper');

                        orderList.innerHTML += optionItem;
                    });
                }
            }, 1000);
        });
    },

    /**
     * Vai detectar o click para ativar o item da ordenação nativa
    */
    detectClickOnOrdersSelection: function(){
        window.addEventListener('load', () => {
            setTimeout(() => {
                let orderItems = Array.from( category.querySelectorAll('.filters__order .order__wrapper div') );
                let orderNativeItems = Array.from( category.querySelectorAll('#component-products-filter-root .vnda-products-filter-vertical-sort-container .component-products-filter-block .list-value-container') );
                let button = category.querySelector('#component-products-filter-root .vnda-products-filter-vertical-button-apply');

                if( orderItems.length > 0 ){
                    orderItems.forEach(item => {
                        item.addEventListener('click', (event) => {
                            let _this = event.currentTarget;
                            let value = _this.getAttribute('data-value');
    
                            orderNativeItems.forEach(currentOuterItem => {
                                let text = currentOuterItem.querySelector('.list-value-text').textContent;
                                
                                if( value == text ){
                                    simulateClick( currentOuterItem );

                                    setTimeout(() => {
                                        simulateClick( button );
                                    }, 500);
                                }
                            });
                        });
                    });
                }
            }, 1000);
        });
    },

    /**
     * Vai detectar se já existe uma ordenação ativa
    */
    detectActiveOrdersSelection: function(){
        window.addEventListener('load', () => {
            setTimeout(() => {
                let orderNativeItems = Array.from( category.querySelectorAll('#component-products-filter-root .vnda-products-filter-vertical-sort-container .component-products-filter-block .list-value-container') );

                if( orderNativeItems.length > 0 ){
                    orderNativeItems.forEach(currentOuterItem => {
                        if( currentOuterItem.classList.contains('component-products-filter-label-selected') ){
                            let text = currentOuterItem.querySelector('.list-value-text span').textContent;

                            category.querySelector(`.filters__order .order__wrapper div[data-value="${text}"]`).classList.add('active');
                        }
                    });
                }
            }, 1000);
        });
    },

    /**
     * Adiciona um ícone no botão de limpar filtros
    */
    addIconOnClearButton: function(){
        window.addEventListener('load', () => {
            setTimeout(() => {
                let clearButton = category.querySelector('#component-products-filter-root .vnda-products-filter-vertical-buttons .vnda-products-filter-vertical-button-clear');

                if( clearButton != null ){
                    clearButton.innerHTML = 'Limpar Filtros <svg fill=none height=23 viewBox="0 0 19 23"width=19 xmlns=http://www.w3.org/2000/svg><path d="M1.18412 6.98298C1.09194 6.87883 1.03117 6.74946 1.00918 6.61056C0.987186 6.47167 1.00492 6.3292 1.06022 6.20044C1.11553 6.07168 1.20603 5.96216 1.32075 5.88515C1.43548 5.80815 1.5695 5.76697 1.70658 5.7666H17.2917C17.4289 5.76662 17.5631 5.80754 17.6781 5.88441C17.7931 5.96128 17.8839 6.07078 17.9394 6.19961C17.9949 6.32844 18.0128 6.47105 17.9909 6.61012C17.969 6.74918 17.9082 6.87871 17.8159 6.98298L11.8174 13.5567C11.6945 13.6915 11.6261 13.8693 11.6261 14.0539V19.0985C11.6262 19.2183 11.5975 19.3362 11.5425 19.4418C11.4875 19.5475 11.4079 19.6375 11.3109 19.704L8.47723 21.6431C8.37062 21.7166 8.24656 21.759 8.11831 21.7657C7.99007 21.7724 7.86245 21.7432 7.74913 21.6812C7.6358 21.6192 7.54102 21.5267 7.47492 21.4137C7.40883 21.3006 7.3739 21.1713 7.37388 21.0395V14.0539C7.37393 13.8693 7.30555 13.6915 7.18261 13.5567L1.18412 6.98298Z"stroke=#F20512 stroke-linecap=round stroke-linejoin=round /><path d="M0.898438 0.545898L16.8237 16.4712"stroke=#F20512 stroke-linecap=round /></svg>';
                }
            }, 1000);
        });
    },

    /**
     * Adiciona um ícone no botão de aplicar filtros
    */
    addIconOnApplyButton: function(){
        window.addEventListener('load', () => {
            setTimeout(() => {
                let applyButton = category.querySelector('#component-products-filter-root .vnda-products-filter-vertical-buttons .vnda-products-filter-vertical-button-apply');

                if( applyButton != null ){
                    applyButton.innerHTML = 'Aplicar <svg fill=none height=23 viewBox="0 0 19 23"width=19 xmlns=http://www.w3.org/2000/svg><path d="M1.18412 6.98298C1.09194 6.87883 1.03117 6.74946 1.00918 6.61056C0.987186 6.47167 1.00492 6.3292 1.06022 6.20044C1.11553 6.07168 1.20603 5.96216 1.32075 5.88515C1.43548 5.80815 1.5695 5.76697 1.70658 5.7666H17.2917C17.4289 5.76662 17.5631 5.80754 17.6781 5.88441C17.7931 5.96128 17.8839 6.07078 17.9394 6.19961C17.9949 6.32844 18.0128 6.47105 17.9909 6.61012C17.969 6.74918 17.9082 6.87871 17.8159 6.98298L11.8174 13.5567C11.6945 13.6915 11.6261 13.8693 11.6261 14.0539V19.0985C11.6262 19.2183 11.5975 19.3362 11.5425 19.4418C11.4875 19.5475 11.4079 19.6375 11.3109 19.704L8.47723 21.6431C8.37062 21.7166 8.24656 21.759 8.11831 21.7657C7.99007 21.7724 7.86245 21.7432 7.74913 21.6812C7.6358 21.6192 7.54102 21.5267 7.47492 21.4137C7.40883 21.3006 7.3739 21.1713 7.37388 21.0395V14.0539C7.37393 13.8693 7.30555 13.6915 7.18261 13.5567L1.18412 6.98298Z"stroke=#F20512 stroke-linecap=round stroke-linejoin=round /><path d="M0.898438 0.545898L16.8237 16.4712"stroke=#F20512 stroke-linecap=round /></svg>';
                }
            }, 1000);
        });
    },

    /**
     * Abre e fecha a modal de filtros de ordenação
    */
    openAndCloseOrderFilters: function(){
        let button = category.querySelector('.filters__order .order__title');
        let modal = category.querySelector('.filters__order .order__wrapper');

        button.addEventListener('click', (event) => {
            let _this = event.currentTarget;

            if( _this.classList.contains('active') ){
                fadeOutEffect( modal );

                _this.classList.remove('active');

            } else {
                if( isMobile == false ){
                    fadeOutEffect( category.querySelector('.category__filters .filters__filter .filter__wrapper') );
                    category.querySelector('.category__filters .filters__filter .filter__title').classList.remove('active');
                }

                fadeInEffect( modal );

                _this.classList.add('active');
            }
        });
    },

    /**
     * Abre e fecha a modal de filtros
    */
    openAndCloseFilters: function(){
        let button = category.querySelector('.category__filters .filter__title');
        let modal = category.querySelector('.category__filters .filter__wrapper');

        button.addEventListener('click', (event) => {
            let _this = event.currentTarget;

            if( _this.classList.contains('active') ){
                fadeOutEffect( modal );

                _this.classList.remove('active');

            } else {
                fadeOutEffect( category.querySelector('.category__filters .filters__order .order__wrapper') );
                category.querySelector('.category__filters .filters__order .order__title').classList.remove('active');

                fadeInEffect( modal );

                _this.classList.add('active');
            }
        });
    },

    /**
     * Adiciona um título e o botão de fechar os filtros na versão mobile
    */
    addTitleAndCloseButtonOnFilterBlockOnMobile: function(){
        window.addEventListener('load', () => {
            setTimeout(() => {
                let element =  `<div class="filter__header">
                                    <div class="header__title">
                                        <span>Filtros</span>
                                    </div>

                                    <div class="header__close">
                                        <svg class="filter__close" fill=none height=16 viewBox="0 0 16 16"width=16 xmlns=http://www.w3.org/2000/svg><rect fill=#4F4F4F height=18.8419 rx=1.4408 transform="matrix(0.706574 -0.707639 0.706574 0.707639 0.5625 2.125)"width=2.8816 /><rect fill=#4F4F4F height=18.8419 rx=1.56326 transform="matrix(0.706574 0.707639 -0.706574 0.707639 13.7891 0)"width=3.12653 /></svg>
                                    </div>
                                </div>`;
                let filterBlock = category.querySelector('.category__filters #component-products-filter-root');;

                if( filterBlock != null ){
                    filterBlock.insertAdjacentHTML('afterbegin', element);
                }
            }, 1000);
        });
    },

    /**
     * Abre e fecha a modal de filtros na versão mobile
    */
    openAndCloseFiltersOnMobile: function(){
        window.addEventListener('load', () => {
            setTimeout(() => {
                let button = category.querySelector('.category__filters .filter__title');
                let buttonClose = category.querySelector('.category__filters #component-products-filter-root .filter__close');
                let modal = category.querySelector('.category__filters .filter__wrapper');
                let duration = 500;

                button.addEventListener('click', (event) => {
                    modal.style.left = 0;
                    modal.style.transitionDuration = duration + 'ms';
                });

                buttonClose.addEventListener('click', (event) => {
                    modal.style.left = '-100%';
                    modal.style.transitionDuration = duration + 'ms';
                });
            }, 1000);
        });
    },

    /**
     * Adiciona setas para abrir e fechar o respectivo filtro clicado
    */
    addIconAndOpenCloseFilterClicked: function(){
        window.addEventListener('load', () => {
            setTimeout(() => {
                let icon = `<div class="filter__arrow"><svg fill=none height=6 viewBox="0 0 10 6"width=10 xmlns=http://www.w3.org/2000/svg><path d="M5.32157 5.86027L9.8667 1.31514C9.93033 1.25158 9.97368 1.17056 9.99125 1.08235C10.0088 0.994131 9.99981 0.902688 9.96538 0.819592C9.93095 0.736497 9.87264 0.665486 9.79783 0.615548C9.72302 0.56561 9.63508 0.538992 9.54513 0.539063L0.454871 0.539062C0.364925 0.538991 0.27698 0.56561 0.20217 0.615547C0.12736 0.665485 0.0690489 0.736496 0.0346184 0.819592C0.000187858 0.902687 -0.00881388 0.994131 0.00875375 1.08234C0.0263204 1.17056 0.0696659 1.25158 0.133303 1.31514L4.67843 5.86027C4.72064 5.90253 4.77077 5.93606 4.82595 5.95893C4.88113 5.9818 4.94027 5.99357 5 5.99357C5.05973 5.99357 5.11887 5.9818 5.17405 5.95893C5.22923 5.93606 5.27936 5.90253 5.32157 5.86027Z"fill=#F20512 /></svg></div>`;

                /**
                 * Adiciona a classe "filter__block" para ajudar na procura dos elementos para futuras funções
                 * @param {HTMLDivElement} element - Elemento a ser selecionado para adicionar a classe
                */
                const addClass = ( element ) => {
                    let elements = Array.from( category.querySelectorAll(`#component-products-filter-root ${element}`) );

                    if( elements.length > 0 ){
                        elements.forEach(currentElement => {
                            currentElement.classList.add('filter__block');
                        });
                    }
                }

                /**
                 * Abre o bloco do filtro cliado e fechas os respectivos filtros que já estiverem abertos
                */
                const openAndCloseFiltersBlocks = () => {
                    let items = Array.from( category.querySelectorAll('#component-products-filter-root .filter__block') );

                    if( items.length > 0 ){
                        items.forEach(currentItem => {
                            currentItem.querySelector('.component-products-filter-title').insertAdjacentHTML('beforeend', icon);

                            currentItem.querySelector('.filter__arrow').addEventListener('click', ( event ) => {
                                let _this = event.currentTarget;
                                let counter = 0;

                                if( _this.classList.contains('active') ){
                                    slideUp( _this.closest('.filter__block').querySelector('.component-products-filter-my-4'), 500 );

                                    _this.classList.remove('active');

                                } else {
                                    items.forEach(currentOuterItem => {
                                        slideUp( currentOuterItem.querySelector('.component-products-filter-my-4'), 500 );
            
                                        currentOuterItem.querySelector('.filter__arrow').classList.remove('active');

                                        counter++
            
                                        // Se o número do "counter" for igual ao número de items do menu, vai abrir o submenu atual que foi clicado
                                        if (counter === items.length) {
                                            setTimeout(() =>{
                                                slideDown( _this.closest('.filter__block').querySelector('.component-products-filter-my-4'), 500 );
                                            }, 500);
                                        }
                                    });

                                    _this.classList.add('active');
                                }
                            });
                        });
                    }
                }

                addClass( '.vnda-products-filter-vertical-tags-container' );
                addClass( '.vnda-products-filter-vertical-properties-container' );
                addClass( '.vnda-products-filter-price-filter-container' );
                addClass( '.vnda-products-filter-vertical-sort-container' );

                openAndCloseFiltersBlocks();
            }, 1000);
        });
    },

    /**
     * Adiciona um botão fake de filtrar na versão mobile
    */
    addFakeButtonFilterOnMobile: function(){
        window.addEventListener('load', () => {
            setTimeout(() => {
                let orderNativeItems = Array.from( category.querySelectorAll('#component-products-filter-root .vnda-products-filter-vertical-sort-container .component-products-filter-block .list-value-container') );

                if( orderNativeItems.length > 0 ){
                    let button = `<div class="filter__button--mobile"><span>Aplicar</span></div>`;
                
                    category.querySelector('.category__filters #component-products-filter-root').insertAdjacentHTML('afterbegin', button);

                    category.querySelector('.category__filters #component-products-filter-root .filter__button--mobile').addEventListener('click', () => {
                        simulateClick( category.querySelector('.category__filters #component-products-filter-root .vnda-products-filter-vertical-button-apply') );
                    });
                }
            }, 1000);
        });
    },

    /**
     * Adiciona o botão de fechar a modal de filtros na versão desktop
    */
    addCloseButtonOnDesktop: function(){
        window.addEventListener('load', () => {
            setTimeout(() => {
                let orderNativeItems = Array.from( category.querySelectorAll('#component-products-filter-root .vnda-products-filter-vertical-sort-container .component-products-filter-block .list-value-container') );

                if( orderNativeItems.length > 0 ){
                    let closeButtonHtml = `<div class="filter__close"><div class="close__inner"><svg fill=none height=16 viewBox="0 0 16 16"width=16 xmlns=http://www.w3.org/2000/svg><rect fill=#4F4F4F height=18.8419 rx=1.4408 transform="matrix(0.706574 -0.707639 0.706574 0.707639 0.5625 2.12598)"width=2.8816 /><rect fill=#4F4F4F height=18.8419 rx=1.56326 transform="matrix(0.706574 0.707639 -0.706574 0.707639 13.7891 0)"width=3.12653 /></svg></div></div>`;
                    category.querySelector('.category__filters .filters__filter .filter__wrapper').insertAdjacentHTML('afterbegin', closeButtonHtml);

                    let modal = category.querySelector('.category__filters .filter__wrapper');
                    let closeButton = category.querySelector('.category__filters .filters__filter .filter__close .close__inner');

                    closeButton.addEventListener('click', () => {
                        fadeOutEffect( modal );

                        category.querySelector('.category__filters .filters__filter .filter__title').classList.remove('active');
                    });
                }
            }, 1000);
        });
    },

    init: function(){
        const _this = this;

        _this.setBannersCategories();
        _this.getOrdersSelectionAndBuild();
        _this.detectClickOnOrdersSelection();
        _this.detectActiveOrdersSelection();
        _this.addIconOnClearButton();
        _this.addIconOnApplyButton();
        //_this.detectClickOnFilterItemAndActiveButton();
        _this.openAndCloseOrderFilters();
        
        if( isMobile == false ){
            _this.openAndCloseFilters();
            _this.addCloseButtonOnDesktop();
        }

        if( isMobile == true ){
            _this.addTitleAndCloseButtonOnFilterBlockOnMobile();
            _this.openAndCloseFiltersOnMobile();
            _this.addIconAndOpenCloseFilterClicked();
            _this.addFakeButtonFilterOnMobile();
        }
    },
}

export default categoryFunctions;